export default __webpack_public_path__ + "static/media/image7.386aea3d.png";